// @flow
import * as React from 'react';

import { Icon, IconContainer, Line, Main, Number, NumberContainer } from './styles';

import type { AnyIcon } from '~/core/constants/icons';
import { actionTypes } from '~/core/constants/actions';
import generalIcons from '~/core/constants/icons/general-svg';

const minValueToShowNumber = 2;

type Props = {
    _while?: AnyIcon,
    when: AnyIcon,
    then?: {
        type: AnyIcon | typeof actionTypes.MIXED,
        count?: number
    },
    disabled?: boolean
};
export default ({ when, _while, then, disabled = false }: Props) => (
    <Main number={1 + (_while ? 1 : 0) + (then ? 1 : 0)}>
        <Line disabled={disabled} />
        <IconContainer disabled={disabled}>
            <Icon type={when} />
        </IconContainer>
        {_while && (
            <IconContainer disabled={disabled}>
                <Icon type={_while} />
            </IconContainer>
        )}
        {then && (
            <IconContainer disabled={disabled}>
                <Icon type={then.type === actionTypes.MIXED ? generalIcons.MORE_VERTICAL : then.type} />
                {then.count &&
                    then.count >= minValueToShowNumber && (
                        <NumberContainer>
                            <Number>{then.count}</Number>
                        </NumberContainer>
                    )}
            </IconContainer>
        )}
    </Main>
);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/icons-summary/component.js